
import { Component, Prop, Vue } from "vue-property-decorator";
import { VPopover } from "v-tooltip";

import Variants from "@/entities/TooltipVariants";

@Component({
  components: {
    VPopover,
  },
})
export default class Tooltip extends Vue {
  @Prop({ type: Number, default: 16 }) readonly offset!: number;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: undefined }) readonly title?: string;
  @Prop({ type: String, default: "top" }) readonly placement!: string;
  @Prop({ type: String, default: Variants.LIGHT }) readonly variant!: string;
  @Prop({ type: String, default: "w-36" }) readonly tooltipClasses!: string;
  @Prop({ type: String, default: "" }) readonly tooltipPopOverClass!: string;
  @Prop({ type: String, default: "w-36" })
  readonly tooltipContainerClasses!: string;
  @Prop({ type: String, default: "hover" }) readonly trigger!: string;
  @Prop({ type: String, default: "" }) readonly arraowClass!: string;

  @Prop({ type: Boolean, default: false }) readonly fullWidth!: boolean;

  get innerClasses(): Record<string, boolean> {
    return {
      dark: this.variant === Variants.DARK,
      light: this.variant === Variants.LIGHT,
      white: this.variant === Variants.WHITE,
      attention: this.variant === Variants.ATTENTION,
      [this.tooltipClasses]: true,
    };
  }

  get popoverClasses(): Record<string, boolean> {
    return {
      ["popover b-tooltipZ"]: this.fullWidth,
       [this.tooltipPopOverClass]: true,
    };
  }

  get isTooltipDisabled(): boolean {
    return this.disabled || (!this.title && !this.$scopedSlots.content);
  }
}
